import {FormItemProps} from "antd/lib/form";
import {AntdFormValidationObject, AntdFormValues} from "../../helpers/antdFormValidations";
import FormItem from "antd/lib/form/FormItem";
import React from "react";

export const formItemFactory = <FormValues extends AntdFormValues>(validations?: AntdFormValidationObject<FormValues>) => {
  return (props: Omit<FormItemProps<FormValues>, 'name' | 'label' | 'rules'> & { name: keyof FormValues; label: string }): React.ReactElement => {
    return (
      <FormItem<FormValues>
        {...props}
        name={props.name as string}
        {...validations?.getFieldValidation(props.name)}
      >
        {props.children}
      </FormItem>
    );
  }
}